<template>
  <v-btn class="px-12 white--text text-none"
         x-large
         rounded
         :color="color + transparency"
         :disabled="disabled"
         @click="$emit('click')">
    <span class="first-letter-capital">{{ $t(label) }}</span>
  </v-btn>
</template>

<script lang="ts">
import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import colors from '@/helpers/colors';

@Component
export default class ActionButton extends Vue {
  @Prop({ required: true })
  private readonly label!: string;

  @Prop({ default: () => 'FF' })
  private readonly transparency!: string;

  @Prop({ default: () => false })
  private readonly disabled!: boolean;

  private readonly color = colors.pinkButton;
}
</script>
